const authHeaders = () => ({
  Authorization: "Bearer " + sessionStorage.getItem("ZeitroA"),
  Cache: "no-cache",
  "Content-Type": "application/json",
})

async function parseResponse(response) {
  const body = await response.json()
  if (!response.ok || body?.Status !== "OK") {
    throw new Error(body?.Message || body?.Text || `request failed (${response.status})`)
  }
  return body
}

export async function fetchDispositionNoticeV2(loanId) {
  const response = await fetch(`/los/v2/loans/${loanId}/disposition-notice`, {
    method: "GET",
    headers: authHeaders(),
  })
  return parseResponse(response)
}

export async function patchDispositionNoticeV2(loanId, payload) {
  const response = await fetch(`/los/v2/loans/${loanId}/disposition-notice`, {
    method: "PATCH",
    headers: authHeaders(),
    body: JSON.stringify(payload),
  })
  return parseResponse(response)
}

export async function generateDispositionNoticePdfV2(loanId) {
  const response = await fetch(`/los/v2/loans/${loanId}/disposition-notice/pdf`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ loanId }),
  })
  if (!response.ok) {
    const text = await response.text()
    throw new Error(text || `PDF request failed (${response.status})`)
  }
  return response
}
